import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { actionsHandlers, stateFactories } from 'store/entities/utils';
import { TrustProfile } from 'api/admin/models/TrustProfile';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<TrustProfile>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminTrustProfilesReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminTrustProfiles.request.type]: actionsHandlers.handleGetPaginatedManyRequest,
  [actions.getAdminTrustProfiles.success.type]: actionsHandlers.handleGetPaginatedManySuccess,
  [actions.getAdminTrustProfiles.failure.type]: actionsHandlers.handleGetPaginatedManyFailure,
  [actions.getAdminTrustProfiles.reset.type]: actionsHandlers.handleGetPaginatedManyReset,
});

export default adminTrustProfilesReducer;
